export const FEATURE_NAME = '@zerops/zerops/feature/email-verification-notification';

/**
 * API error code returned by `PUT /api/user/:id/send-verification-email` when
 * the e-mail was already verified (typically in another tab / on another device).
 * The local user entity is stale in that case — see the effect that syncs it.
 */
export const EMAIL_ALREADY_VERIFIED_ERROR_CODE = 'emailAlreadyVerified';
